<template>
 	<b-container fluid>
        <b-row class="page-title">
            <b-container fluid>
                <h3>Invoices</h3>
                <hr>
            </b-container>
        </b-row>
        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="tables.invoices.filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                              debounce="500"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!tables.invoices.filter" @click="tables.invoices.filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="3" class="buttons-create">
                        <!-- <b-button variant="outline-primary" size="sm" @click="openModal('listing', [], 'new')">New Listing</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('upload')">Import</b-button>
                        <b-button variant="outline-primary" size="sm" @click="exportinvoices()">Export</b-button> -->
                        <b-button variant="outline-primary" size="sm" @click="openModal('create-invoice', '', 'create')">New Invoice</b-button>
                        <b-button variant="outline-primary" size="sm" @click="">Import</b-button>
                        <b-button variant="outline-primary" size="sm" @click="">Export</b-button>
                    </b-col>

                    <b-col cols="3">
                        <treeselect
                            name="statusSelect"
                            class="statusSelect"
                            clearable
                            :searchable="false"
                            open-on-click
                            clear-on-select
                            close-on-select
                            disableBranchNodes
                            placeholder="Status"
                            :options="tables.invoices.status"
                            @input="filterByStatus"
                            />
                    </b-col>

                    <b-col cols="3">
                        <b-form-group>
                          <b-form-select
                            v-model="tables.invoices.perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="tables.invoices.pageOptions"
                          ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-invoices-table">
                    <b-container fluid>
                        <b-table
                            ref="invoicesTable"
                            :key="tables.invoices.key"
                            class="invoices-table"
                            responsive bordered
                            hover no-border-collapse
                            sticky-header="600px"
                            head-variant="light"
                            :items="invoicesProvider"
                            :fields="tables.invoices.fields"
                            :sort-by.sync="tables.invoices.sortBy"
                            :sort-desc.sync="tables.invoices.sortDesc"
                            :per-page="tables.invoices.perPage"
                            :current-page.sync="tables.invoices.currentPage"
                            :filter="tables.invoices.filter"
                            :busy.sync="tables.invoices.isBusy"
                        >

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(customer)="row">
                                <span v-if="row.item.customer">{{ row.item.customer.name }}</span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(total)="row">
                                <span v-if="row.item.total">${{ row.item.total }}</span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(sales_rep)="row">
                                <span v-if="row.item.sales_rep">{{ row.item.sales_rep.name }}</span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(source)="row">
                                <span>{{ row.item.source.source_type.name}}</span>
                            </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <!-- <b-col>
                                            <b-link @click="openModal('listing', row.item, 'edit')"><i class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <b-col>
                                            <b-link @click="showMsgBoxDeleteConfirm('invoices', row.item)" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                        <b-col>
                                            <b-link @click=""><i class="far fa-check-square"></i></b-link>
                                        </b-col>
                                        <b-col>
                                            <b-link @click=""><i class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <b-col>
                                            <b-link @click="repushToSB(row.item.id, row.item.customer.name + ' (#' + row.item.marketplace_order_number + ')')"><i class="fas fa-sync"></i></b-link>
                                        </b-col>
                                        <!-- <b-col>
                                            <b-link @click="" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination
                          v-model="tables.invoices.currentPage"
                          :total-rows="tables.invoices.totalRows"
                          :per-page="tables.invoices.perPage"
                          align="fill"
                          size="sm"
                          class="my-0"
                        ></b-pagination>
                    </b-col>
                </b-row>

                <b-modal id="modal-inventory-invoices-create-invoice" hide-footer>
                    <template v-slot:modal-title>
                        New Product: {{ modals['create-invoice'].create.sku }}
                    </template>

                    <b-form @submit.stop.prevent="createProduct">
                        <b-form-group
                            id="input-group-sku"
                            label="Name:"
                            label-for="input-sku"
                        >
                            <b-form-input
                                id="input-sku"
                                v-model="modals['create-invoice'].create.sku"
                                type="text"
                                required
                                placeholder="Enter SKU"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-image"
                            label="Image:"
                            label-for="input-image"
                        >
                            <b-form-file
                                id="input-image"
                                v-model="modals['create-invoice'].create.image"
                                :state="Boolean(modals['create-invoice'].create)"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                            ></b-form-file>
                        </b-form-group>

                        <b-form-group
                            id="input-group-categories"
                            label="Category:"
                            label-for="input-categories"
                        >
                            <treeselect
                                name="treeSelect"
                                class="treeSelect"
                                clearable
                                searchable
                                open-on-click
                                clear-on-select
                                close-on-select
                                disableBranchNodes
                                placeholder=""
                                :options="tables.invoices.status"
                                v-model="modals['create-invoice'].create.statusSelected"
                                />
                        </b-form-group>

                        <b-form-group
                            id="input-group-description"
                            label="Description:"
                            label-for="input-description"
                        >
                            <b-form-input
                                id="input-description"
                                v-model="modals['create-invoice'].create.description"
                                type="text"
                                required
                                placeholder="Enter Description"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-row>
                            <b-col>
                                <b-form-group
                                    id="input-group-qty"
                                    label="QTY:"
                                    label-for="input-qty"
                                >
                                    <b-form-input
                                        id="input-qty"
                                        v-model="modals['create-invoice'].create.qty_total"
                                        type="text"
                                        required
                                        placeholder="Enter QTY"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-qty-a"
                                    label="QTY (A):"
                                    label-for="input-qty-a"
                                >
                                    <b-form-input
                                        id="input-qty-a"
                                        v-model="modals['create-invoice'].create.qty_wh_a"
                                        type="text"
                                        required
                                        placeholder="Enter QTY (A)"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-qty-b"
                                    label="QTY (B):"
                                    label-for="input-qty-b"
                                >
                                    <b-form-input
                                        id="input-qty-b"
                                        v-model="modals['create-invoice'].create.qty_wh_b"
                                        type="text"
                                        required
                                        placeholder="Enter QTY (B)"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group
                                    id="input-group-cost"
                                    label="Cost:"
                                    label-for="input-cost"
                                >
                                    <b-form-input
                                        id="input-cost"
                                        v-model="modals['create-invoice'].create.cost"
                                        type="text"
                                        required
                                        placeholder="Enter Cost"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-price"
                                    label="Price:"
                                    label-for="input-price"
                                >
                                    <b-form-input
                                        id="input-price"
                                        v-model="modals['create-invoice'].create.price"
                                        type="text"
                                        required
                                        placeholder="Enter Price"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-form-group>
                            <b-form-checkbox
                                id="checkbox-active"
                                v-model="modals['create-invoice'].create.active"
                                name="checkbox-active"
                                value="1"
                                unchecked-value="0"
                            >
                              Active
                            </b-form-checkbox>
                        </b-form-group>

                        <b-button type="submit" variant="primary">
                            <span v-if="modals['create-invoice'].submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Updating...
                            </span>
                            <span v-else>Create</span>
                        </b-button>
                    </b-form>
                </b-modal>
            </b-container>
        </b-row>
    </b-container>
 	</div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
 	export default {
    	name: 'invoices',
    	components: {
      		Treeselect
    	},
        data() {
            return {
                modals: {
                    'create-invoice': {
                        create: {active: 1},
                        key: 1,
                        submitting: 0,
                        statusSelected: []
                    },

                    'edit-invoice': {
                        edit: [],
                        key: 1,
                        submitting: 0
                    },
                },
                selectedStatus: null,
                tables: {
                    invoices: {
                        isBusy: false,
                        totalRows: 0,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'date_completed',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        fields: [
                            {
                                key: 'id',
                                label: 'ID',
                                sortable: true
                            },
                            {
                                key: 'marketplace_order_number',
                                label: 'Invoice #',
                                sortable: true
                            },
                            {
                                key: 'customers_id',
                                label: 'Customer ID',
                                sortable: true
                            },
                            {
                                key: 'customer',
                                label: 'Customer',
                                sortable: true
                            },
                            {
                                key: 'total',
                                label: 'Total',
                                sortable: true
                            },
                            {
                                key: 'date_completed',
                                label: 'Order Placed',
                                sortable: true,
                                thClass: 'invoices-table-style-datetime'
                            },
                            {
                                key: 'source',
                                label: 'Source',
                                sortable: true
                            },
                            {
                                key: 'status',
                                label: 'Progress',
                                sortable: true
                            },
                            {
                                key: 'payment_method',
                                label: 'Payment Method',
                                sortable: true
                            },
                            {
                                key: 'dispatched_by',
                                label: 'Dispatcher',
                                sortable: true
                            },
                            {
                                key: 'sales_rep',
                                label: 'Sales Rep',
                                sortable: true
                            },
                            {
                                key: 'shipping_method',
                                label: 'Ship Method',
                                sortable: true
                            },
                            {
                                key: 'tracking_number',
                                label: 'Tracking #',
                                sortable: true
                            },
                            {
                                key: 'sync_status',
                                label: 'Sync Status',
                                sortable: true
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'invoices-table-style-actions'
                            }
                        ],

                        items: [],
                        categories: []
                    },
                },
            }
        },
        methods: {
            openModal(modalName, row) {
                let prefix = 'modal-inventory-invoices-'
                switch (modalName) {
                    case 'edit-invoice':
                        this.modals[modalName].edit = Object.assign({}, row)
                        // this.setCurrentUserRoles(row.roles)

                        break;
                }

                this.$bvModal.show(prefix + modalName)
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },

            toggleBusy() {
                this.tables.invoices.isBusy = !this.tables.invoices.isBusy
            },

            repushToSB(id, info) {
                let url = 'api/orders/invoices/repushtosb/' + id
                axios.get(url, {})
                .then((res) => {
                    this.showAlertBox('success', 'Invoice Refreshed', info)
                }, () => {
                    this.has_error = true
                })
            },

            invoicesProvider(ctx) {
                return this.scheduleProviderFetch('invoices', ctx, (latestCtx) => {
                    const normalized = this.normalizeTableProviderContext(latestCtx, this.tables.invoices)
                    let payload = {
                        status: this.selectedStatus,
                        page: normalized.currentPage,
                        perPage: normalized.perPage,
                        sortBy: normalized.sortBy,
                        sortDesc: normalized.sortDesc,
                        search: normalized.filter
                    }

                    return axios.post('api/orders/invoices/getinvoices', payload)
                    .then((res) => {
                        this.tables.invoices.items = res.data.orders
                        this.tables.invoices.totalRows = res.data.total
                        return res.data.orders || []
                    }, () => {
                        this.has_error = true
                        return []
                    })
                })
            },

            refreshInvoicesTable() {
                if (this.$refs.invoicesTable) {
                    this.$refs.invoicesTable.refresh()
                }
            },

            filterByStatus(catId) {
                this.selectedStatus = catId
                this.tables.invoices.currentPage = 1
                this.refreshInvoicesTable()
            },

            findCategoryName(id) {
                let index = this.findIndex(this.tables.invoices.status, 'id', id)
                return this.tables.invoices.status[index].label
            },

            getCategories() {
                let url = 'api/orders/invoices/getcategoriesfilter'
                axios.get(url, {})
                .then((res) => {
                    this.tables.invoices.status = res.data.categories
                }, () => {
                    this.has_error = true
                })
            }
        },
    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.invoices.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.invoices.totalRows
                let currentPage = this.tables.invoices.currentPage
                let perPage = this.tables.invoices.perPage

                if (!totalRows) {
                    return 'Showing 0 of 0 rows'
                }

                let from = ((currentPage - 1) * perPage) + 1
                let to = Math.min(currentPage * perPage, totalRows)

                return 'Showing ' + from + ' to ' + to + ' of ' + totalRows + ' rows'
            }
	    },
	    mounted() {
            // this.getCategories()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-inventory-invoices-edit-invoice':
                        this.modals['edit-invoice'].edit = []

                        break
                    case 'modal-inventory-invoices-create-invoice':
                        this.modals['create-invoice'].create = {}

                        break;
                }
            })

            // pusher
            Echo.channel('table-item-updated')
                .listen('TableItemUpdated', (e) => {
                    this.refreshInvoicesTable()
            })
	    }
  }
</script>
<style lang="scss">
    .buttons-create {

    }

    .vue-treeselect__control {
        // height: calc(1.5em + 0.5rem + 2px);
        // padding-top: 0.25rem;
        // padding-bottom: 0.25rem;
        // padding-left: 0.5rem;
        font-size: 0.875rem !important;

        .vue-treeselect__placeholder, .vue-treeselect__single-value {
            // line-height: 1.5
        }
    }

    .invoices-table {
        font-size: 9pt;

        .invoices-thumbs {
            width: 80px;
            max-height: 80px;
        }

        .invoices-table-style-actions {
            // width: 120px;

            .actions-icons {
                text-align: center;
            }
        }

        .invoices-table-style-datetime {
            width: 110px;

            .actions-icons {
                text-align: center;
            }
        }
    }
</style>
